<template>
    <button v-on="$listeners" class="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-4 py-3 rounded flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white focus:outline-none focus:shadow-outline transition duration-150 ease-in-out"><slot></slot></button>
</template>

<script>
  export default {
    data() {
      return {};
    },
  };
</script>

<style>

</style>